import React from 'react';
import { Box, Typography, List, ListItemButton, ListItemText, IconButton, Tooltip } from '@mui/material';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

const HistoryItem = ({ item, onSelect }) => {
  const methodColor = {
    GET: 'success.main',
    POST: 'warning.main',
    PUT: 'info.main',
    PATCH: 'info.light',
    DELETE: 'error.main',
  };

  return (
    <ListItemButton onClick={() => onSelect(item.id)} sx={{ borderRadius: 1, mb: 0.5 }}>
      <ListItemText
        primary={
          <Typography variant="body2" sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'flex',
            alignItems: 'center',
          }}>
            <Typography component="span" sx={{ fontWeight: 'bold', color: methodColor[item.method] || 'text.primary', minWidth: '35px', textAlign: 'left' }}>
              {item.method}
            </Typography>
            <Typography component="span" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {item.baseUrl}
            </Typography>
          </Typography>
        }
      />
    </ListItemButton>
  );
};

const HistoryPanel = ({ history, onSelect, onClear }) => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6" sx={{ pl: 1 }}>History</Typography>
        <Tooltip title="Clear History">
          <span>
            <IconButton onClick={onClear} disabled={history.length === 0}>
              <DeleteSweepIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
        <List dense>
          {history.map(item => (
            <HistoryItem key={item.id} item={item} onSelect={onSelect} />
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default HistoryPanel;
